"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.theme = void 0;
exports.theme = {
    colors: {
        red1: "#C81808",
        red2: "#E71A0F",
        red3: "#FDC6C1",
        red4: "#FEE4E2",
        red5: "#FEF3F2",
        black: "#192A3E",
        tableBlack1: "#222931",
        tableBlack2: "#323C47",
        tableGray1: "#707683",
        tableGray2: "#B7BBC1",
        tableGray3: "#323C47",
        white: "#FFFFFF",
        darkBlueText: "#334D6E",
        azure1: "rgb(226,230,238)",
        green: "#24695B",
        yellow: "#F1B601",
        purple: "#744988",
        gray1: "#727171",
        gray2: "#B5B6B6",
        gray3: "#D5D5D5",
        gray4: "#F2F2F2",
        gray5: "#686D75",
        // 202009 追加
        bg: "#403D3C",
        archived: "#868B92",
        error: "#C81D09",
        warnText: "#F1B601",
        warn: "#A66111",
        ok: "#24695B",
        // 以下自分で勝手に追加したもの
        gray2Transparent: "#EFF0F0",
        gray2Transparent2: "#F8F8F8",
        background: "#F5F6F8",
    },
    borderRadius: {
        all: "4px",
        above: "4px 4px 0 0",
        beneath: "0 0 4px 4px",
        leftTop: "4px 0 0 0",
        leftBottom: "0 0 0 4px",
        rightTop: "0 4px 0 0",
        rightBottom: "0 0 4px 0",
    },
    standard: {
        fontSize: "13px",
        boxShadow: "6px 0 18px rgba(0, 0, 0, 0.06)",
    },
};
